/**
 * Wrap Vuelidate's built-in validators, in order to customize the error
 * messages.
 * 
 * https://vuelidate-next.netlify.app/advanced_usage.html#i18n-support
 */

import * as validators from '@vuelidate/validators'
import i18n from "../plugins/i18n"

const { createI18nMessage } = validators

const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) })

export const email = withI18nMessage(validators.email)
export const decimal = withI18nMessage(validators.decimal, { withArguments: true })
export const integer = withI18nMessage(validators.integer, { withArguments: true })
export const minLength = withI18nMessage(validators.minLength, { withArguments: true })
export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true })
export const minValue = withI18nMessage(validators.minValue, { withArguments: true })
export const maxValue = withI18nMessage(validators.maxValue, { withArguments: true })
export const required = withI18nMessage(validators.required)
// export const requiredIf = withI18nMessage(validators.requiredIf)
export const url = withI18nMessage(validators.url)
